export default "__VITE_ASSET__BSkOPUAs__"